import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import CierreCard from "./CierreCard";

export default function CierresSection({
  title,
  emptyMessage,
  closures,
  variant,
  loading,
  error,
  deletingId,
  downloadingPdfId,
  showPdfAction = false,
  onContinue,
  onDelete,
  onViewMovements,
  onViewCash,
  onViewSummary,
  onViewReport,
  onDownloadPdf,
}) {
  return (
    <Stack spacing={1.2}>
      {title ? (
        <Typography sx={{ fontSize: 15, fontWeight: 900, color: "primary.900" }}>
          {title}
        </Typography>
      ) : null}

      <Box
        sx={{
          p: 1.1,
          borderRadius: "18px",
          bgcolor: "rgba(160, 161, 177, 0.82)",
          minHeight: 96,
        }}
      >
        {loading ? (
          <Stack alignItems="center" spacing={1.2} sx={{ py: 4, bgcolor: "neutral.50", borderRadius: "14px" }}>
            <CircularProgress size={30} />
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "primary.900" }}>
              Cargando cierres...
            </Typography>
          </Stack>
        ) : null}

        {!loading && error ? (
          <Alert severity="error" sx={{ borderRadius: "14px" }}>
            {error}
          </Alert>
        ) : null}

        {!loading && !error && closures.length === 0 ? (
          <Box sx={{ py: 4, px: 2, bgcolor: "neutral.50", borderRadius: "14px", textAlign: "center" }}>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "neutral.700" }}>
              {emptyMessage}
            </Typography>
          </Box>
        ) : null}

        {!loading && !error && closures.length > 0 ? (
          <Stack spacing={0.9}>
            {closures.map((closure) => (
              <CierreCard
                key={closure.id}
                closure={closure}
                variant={variant}
                deleting={String(deletingId) === String(closure.id)}
                downloadingPdf={String(downloadingPdfId) === String(closure.id)}
                showPdfAction={showPdfAction}
                onContinue={onContinue}
                onDelete={onDelete}
                onViewMovements={onViewMovements}
                onViewCash={onViewCash}
                onViewSummary={onViewSummary}
                onViewReport={onViewReport}
                onDownloadPdf={onDownloadPdf}
              />
            ))}
          </Stack>
        ) : null}
      </Box>
    </Stack>
  );
}
